// Dependecies
import React, { useState, forwardRef } from 'react';
import { useTranslation } from 'react-i18next';

// Images
import Eye from '../../../sass/images/ver-ocultar.svg';
import EyeSlash from '../../../sass/images/ocultar.svg';

const PasswordChangeInput = forwardRef(function PasswordChangeInput(props, ref) {
  const { t } = useTranslation('alt', { useSuspense: false });
  const [isPasswordShow, setIsPasswordShow] = useState(false);

  return (
    <>
      <input ref={ref} type={isPasswordShow ? 'text' : 'password'} {...props} autoComplete="on" />
      <span
        className={isPasswordShow ? 'text eye' : 'password eye'}
        onClick={() => setIsPasswordShow(!isPasswordShow)}
      >
        {isPasswordShow ? (
          <img src={Eye} alt={t('show_password')} />
        ) : (
          <img src={EyeSlash} alt={t('hidden_password')} />
        )}
      </span>
    </>
  );
});

export default PasswordChangeInput;
